import { Button } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { AtsCompanyActiveJobsDocument, AtsRequestUpsellDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import useCreateUpsellRequest, { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  onClose: () => void
  usageLimit: number
  companyId: number
}

const UNLIMITED_JOBS = -1
const ATS_FIVE_ACTIVE_JOBS = 5
const ATS_TEN_ACTIVE_JOBS = 10

export const UpsellPlan = ({ onClose, usageLimit, companyId }: Props) => {
  const manualUpsellData = {
    requestReason: ValidReasons.MissingFeature,
    featureRequested: Features.ats_active_jobs,
    requestSource: 'Overlimits job opening creation',
  }

  const { create } = useCreateUpsellRequest()
  const onRequestManualUpsell = async () => {
    const result = await create({ moduleRequested: AvailableModules.ats, ...manualUpsellData })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.upgrade_modal.thank_you_modal.description'),
        time: 5000,
      })
      onClose()
    }

    return handled
  }
  const [processUpsell] = useMutation(AtsRequestUpsellDocument, {
    extractorFn: (data) => data.atsMutations.processAtsUpsell,
    refetchQueries: [AtsCompanyActiveJobsDocument],
  })

  const description = () => {
    if (usageLimit === UNLIMITED_JOBS) return null

    if (usageLimit == ATS_FIVE_ACTIVE_JOBS) {
      return i18n.t('ats.jobs.limits.upsell.description.five_jobs')
    }
    if (usageLimit == ATS_TEN_ACTIVE_JOBS) {
      return i18n.t('ats.jobs.limits.upsell.description.ten_jobs')
    }
  }

  const onSubmit = async () => {
    const result = await processUpsell({ variables: { companyId } })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
      onClose()
    }

    return handled
  }

  return (
    <Modal
      onClose={onClose}
      onSubmit={() => onSubmit()}
      title={i18n.t('ats.jobs.limits.upsell.title')}
      description={description()}
      illustration="crown"
      footer={
        <>
          <Button onClick={() => onRequestManualUpsell()} type="secondary">
            {i18n.t('ats.jobs.limits.upsell.contact')}
          </Button>
          <Button submit>{i18n.t('ats.jobs.limits.upsell.confirm')}</Button>
        </>
      }
    />
  )
}
